let sectionVideo = document.querySelectorAll('.block_image_video');

if (sectionVideo) {
    sectionVideo.forEach(function (el) {
        // webM
        let videoHolder = el.querySelector('.video-holder');
        let video = el.querySelector('.video-holder video');
        // embed
        const youtubeHolder = el.querySelector('.youtube-holder');
        const embedHolder = el.querySelector('.youtube-holder .embed');
        //mixed
        let playButtons = el.querySelectorAll('.block_image_video .button-play');

        if (videoHolder) {
            if (video) {
                var videoSource = video.getElementsByTagName('source');
                var closeButton = videoHolder.querySelector('.close-video');
            }

            playButtons.forEach(function (el) {
                el.addEventListener('click', playVideo);
            });

            if (video) {
                closeButton.addEventListener('click', stopVideo);
            }

            function playVideo() {
                const videoWebm = this.getAttribute('data-video-webm');
                const videoMp4 = this.getAttribute('data-video-mp4');

                videoSource[0].src = videoWebm;
                videoSource[1].src = videoMp4;
                videoHolder.style.display = 'block';

                video.load();
                video.play();
            }

            function stopVideo() {
                videoHolder.style.display = 'none';
                video.pause();
            }
        }

        if (youtubeHolder) {
            let closeButton = youtubeHolder.querySelector('.close-video');

            playButtons.forEach(function (elm) {
                elm.addEventListener('click', function () {
                    //let embedHolder = el.querySelector('.youtube-holder .embed');
                    let iframe = document.createElement('iframe');
                    iframe.setAttribute('frameborder', '0');
                    iframe.setAttribute('allowfullscreen', '');
                    iframe.setAttribute('src', this.dataset.embed + '?rel=0&showinfo=0&autoplay=1&enablejsapi=1');

                    youtubeHolder.style.display = 'block';
                    embedHolder.innerHTML = '';
                    embedHolder.appendChild(iframe);
                });
            });

            closeButton.addEventListener('click', function () {
                youtubeHolder.style.display = 'none';
                embedHolder.innerHTML = '';
            });
        }
    });
}